import { PlantProgress } from "./types";

type DetailKey =
  | "petHeader.plantingDate"
  | "petHeader.afterPlantSave"
  | `petHeader.plantStatus.${PlantProgress["status"]}`
  | "petHeader.growthDays"
  | "petHeader.growthHours"
  | "petHeader.growthMinutes"
  | "petHeader.nextPlantStage";

export function plantDetails(
  plant: PlantProgress,
  t: (
    key: DetailKey,
    options?: { date?: string; count?: number; time?: string }
  ) => string,
  now = Date.now()
): string {
  const date = plant.plantedAt ? new Date(plant.plantedAt) : null;
  const lines = [
    t("petHeader.plantingDate", {
      date:
        date && Number.isFinite(date.getTime())
          ? new Intl.DateTimeFormat("ru-RU").format(date)
          : t("petHeader.afterPlantSave"),
    }),
    t(`petHeader.plantStatus.${plant.status}`),
  ];
  if (plant.status !== "mature") {
    const remaining = Math.max(
      0,
      plant.remainingSeconds -
        (plant.status === "growing" && plant.sampledAt
          ? Math.max(0, now - plant.sampledAt) / 1000
          : 0)
    );
    const minutes = Math.max(1, Math.ceil(remaining / 60));
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const rest = minutes % 60;
    const time = [
      days ? t("petHeader.growthDays", { count: days }) : "",
      hours ? t("petHeader.growthHours", { count: hours }) : "",
      rest ? t("petHeader.growthMinutes", { count: rest }) : "",
    ]
      .filter(Boolean)
      .join(" ");
    lines.push(t("petHeader.nextPlantStage", { time }));
  }
  return lines.join("\n");
}
